export interface VehicleCondition {
    id: number;
    name: string;
}

export const VEHICLE_CONDITIONS: VehicleCondition[] = [
    { id: 0, name: "Unknown" },
    { id: 1, name: "New" },
    { id: 2, name: "Used" },
    { id: 3, name: "Accident" }
];